import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './style.scss';

interface MainPageLearnMoreProps {
  className?: string;
}

export const SupportConfidential = ({ className }: MainPageLearnMoreProps) => {
  const { t } = useTranslation(['translation']);
  return (
    <Link to={'https://edres.com/confidential'} target="_blank">
      <div className={classNames('SupportConfidential', className)}>
        <div className={classNames('SupportConfidential__content')}>
          <h4>{t('support.confidential')}</h4>
          <p>
            {t('support.confidential_description')}{' '}
            <span>{t('support.confidential_link')}</span>
          </p>
        </div>
      </div>
    </Link>
  );
};
